var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBug } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";
import { fetchDatasetDetails } from "@/api/datasets";
import { fetchJobCommonProblems, fetchJobDetails, postJobErrorReport } from "@/api/jobs";
import { useMarkdown } from "@/composables/markdown";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import DatasetErrorDetails from "@/components/DatasetInformation/DatasetErrorDetails.vue";
import FormElement from "@/components/Form/FormElement.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetError',
    props: {
        datasetId: null
    },
    setup(__props) {
        const props = __props;
        library.add(faBug);
        const userStore = useUserStore();
        const { currentUser } = storeToRefs(userStore);
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true });
        const message = ref("");
        const jobLoading = ref(true);
        const errorMessage = ref("");
        const datasetLoading = ref(false);
        const jobDetails = ref();
        const jobProblems = ref();
        const resultMessages = ref([]);
        const dataset = ref(null);
        const showForm = computed(() => {
            const noResult = !resultMessages.value.length;
            const hasError = resultMessages.value.some((msg) => msg[1] === "danger");
            return noResult || hasError;
        });
        function getDatasetDetails() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                datasetLoading.value = true;
                try {
                    const data = yield fetchDatasetDetails({ id: props.datasetId });
                    dataset.value = data;
                }
                catch (e) {
                    const error = e;
                    errorMessage.value = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.err_msg) || "Unable to fetch available dataset details.";
                }
                finally {
                    datasetLoading.value = false;
                }
            });
        }
        function getJobDetails() {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                jobLoading.value = true;
                try {
                    const { data } = yield fetchJobDetails({ job_id: (_a = dataset.value) === null || _a === void 0 ? void 0 : _a.creating_job, full: true });
                    jobDetails.value = data;
                }
                catch (e) {
                    const error = e;
                    errorMessage.value = ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.err_msg) || "Unable to fetch available dataset details.";
                }
                finally {
                    jobLoading.value = false;
                }
            });
        }
        function getJobProblems() {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield fetchJobCommonProblems({ job_id: (_a = dataset.value) === null || _a === void 0 ? void 0 : _a.creating_job });
                    jobProblems.value = data;
                }
                catch (e) {
                    const error = e;
                    errorMessage.value = ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.err_msg) || "Unable to fetch available dataset details.";
                }
            });
        }
        function submit(dataset, userEmailJob) {
            return __awaiter(this, void 0, void 0, function* () {
                const email = userEmailJob;
                try {
                    const { data } = yield postJobErrorReport({
                        job_id: dataset.creating_job,
                        dataset_id: dataset.id,
                        message: message.value,
                        email,
                    });
                    resultMessages.value = data.messages;
                }
                catch (error) {
                    resultMessages.value = error;
                }
            });
        }
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield getDatasetDetails();
            if (((_a = dataset.value) === null || _a === void 0 ? void 0 : _a.creating_job) !== null) {
                yield getJobDetails();
                yield getJobProblems();
            }
        }));
        return { __sfc: true, props, userStore, currentUser, renderMarkdown, message, jobLoading, errorMessage, datasetLoading, jobDetails, jobProblems, resultMessages, dataset, showForm, getDatasetDetails, getJobDetails, getJobProblems, submit, faBug, FontAwesomeIcon, BAlert, BButton, localize, DatasetErrorDetails, FormElement };
    }
});
